"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Display = _interopRequireDefault(require("@commerce-ui/core2/Display"));
var _Accordion = _interopRequireDefault(require("@commerce-ui/core2/Accordion"));
var _ButtonRaw = _interopRequireDefault(require("@commerce-ui/core2/ButtonRaw"));
var _ShowHide = _interopRequireDefault(require("@commerce-ui/core2/ShowHide"));
var _router = require("next/router");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  resetPosition: false,
  button: __jsx(_ButtonRaw["default"], null),
  rowStyle: {
    px: "20px",
    py: "s7",
    font: "s_sans",
    borderWidth: "1px",
    borderStyle: "solid",
    borderBottomColor: "neutral",
    borderTopColor: "transparent",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    boxSizing: "border-box",
    color: "main",
    width: "100%",
    ":focus": {
      outline: 0,
      boxShadow: "none"
    },
    "::-moz-focus-inner": {
      border: 0
    }
  },
  additionalActiveRowStyles: {
    font: "s_sans_bold",
    borderWidth: "1px",
    borderColor: "main"
  }
};
var SideStickyMenu = function SideStickyMenu(_ref) {
  var _menuData$find$label, _menuData$find;
  var menuData = _ref.menuData,
    initialActiveRow = _ref.initialActiveRow,
    _onClick = _ref.onClick,
    _ref$resetPosition = _ref.resetPosition,
    resetPosition = _ref$resetPosition === void 0 ? defaultProps.resetPosition : _ref$resetPosition,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? defaultProps.button : _ref$button,
    _ref$rowStyle = _ref.rowStyle,
    rowStyle = _ref$rowStyle === void 0 ? defaultProps.rowStyle : _ref$rowStyle,
    _ref$additionalActive = _ref.additionalActiveRowStyles,
    additionalActiveRowStyles = _ref$additionalActive === void 0 ? defaultProps.additionalActiveRowStyles : _ref$additionalActive;
  var router = (0, _router.useRouter)();
  var _useState = (0, _react.useState)(initialActiveRow),
    activeRow = _useState[0],
    setActiveRow = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    accordionOpen = _useState2[0],
    setAccordionOpen = _useState2[1];
  var activeStyle = _objectSpread(_objectSpread({}, rowStyle), additionalActiveRowStyles);
  var buttonStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  };
  var onMenuClick = function onMenuClick(url, urlType) {
    if (urlType === "local") {
      router.push("/info/" + url);
    } else {
      window.open(url, "_blank");
    }
  };
  var mobileMenuOptions = menuData === null || menuData === void 0 ? void 0 : menuData.map(function (menuRaw, index) {
    return menuRaw.url !== activeRow && /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: rowStyle,
      id: menuRaw.url,
      onClick: function onClick(e) {
        _onClick ? _onClick(e) : onMenuClick(menuRaw.url, menuRaw.url_type);
        setActiveRow(menuRaw.url);
        setAccordionOpen(false);
      },
      key: index
    }, menuRaw.label);
  });
  return __jsx(_Box["default"], {
    sx: !resetPosition && {
      position: ["relative", null, "sticky", null],
      top: [0, null, "30vh", null],
      width: ["calc(100% + 10vw)", null, "318px", null],
      left: "-5vw"
    }
  }, __jsx(_Display["default"], {
    when: [true, null, false]
  }, __jsx(_Accordion["default"], null, __jsx(_Accordion["default"].Section, {
    isOpenAtInit: true
  }, /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      width: "100%",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      }
    }
  }, __jsx(_Box["default"], {
    onClick: function onClick() {
      setAccordionOpen(!accordionOpen);
    },
    sx: accordionOpen ? _objectSpread(_objectSpread({}, buttonStyle), activeStyle) : _objectSpread(_objectSpread({}, buttonStyle), rowStyle)
  }, __jsx(_Box["default"], {
    sx: {
      font: "s_sans_bold"
    }
  }, (_menuData$find$label = menuData === null || menuData === void 0 ? void 0 : (_menuData$find = menuData.find(function (option) {
    if (option.url === activeRow) {
      return option;
    }
  })) === null || _menuData$find === void 0 ? void 0 : _menuData$find.label) !== null && _menuData$find$label !== void 0 ? _menuData$find$label : ""), __jsx(_Box["default"], null, accordionOpen ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null)))), resetPosition ? __jsx(_Box["default"], {
    sx: {
      display: accordionOpen ? "block" : "none"
    }
  }, mobileMenuOptions) : __jsx(_ShowHide["default"], null, mobileMenuOptions)))), __jsx(_Display["default"], {
    when: [false, null, true]
  }, menuData.map(function (menuRaw, index) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: activeRow === menuRaw.url ? activeStyle : rowStyle,
      id: menuRaw.url,
      key: index,
      onClick: function onClick(e) {
        setActiveRow(menuRaw.url);
        if (_onClick) {
          _onClick(e);
        } else {
          setAccordionOpen(false);
          onMenuClick(menuRaw.url, menuRaw.url_type);
        }
      }
    }, menuRaw.label);
  })));
};
var _default = SideStickyMenu;
exports["default"] = _default;